import { render, staticRenderFns } from "./DownloadLinkList.vue?vue&type=template&id=c271deb8&scoped=true&"
import script from "./DownloadLinkList.vue?vue&type=script&lang=js&"
export * from "./DownloadLinkList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadLinkList.vue?vue&type=style&index=0&id=c271deb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c271deb8",
  null
  
)

export default component.exports